import { decodeB64WithEncoding } from '../../../../shared/api/base64/decodeB64WithEncoding.js';
import { parseLineBreak } from '../../../../shared/api/html/parseLineBreak.js';

/* EXAMPLE stepData type bm
  {
    "PUB02": "{\"extension\":\"TXT\",\"data\":\"Q29uZGljaW9uZXMgZGUgdXNvIGRlbCBwdWJsaWNhZG9yIFgKClhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWHgKWFhYWFhYWFhYWFhYWFhYWFhYWFhYWHgKWEQK\"}"
  }
*/

export function getContentBM(stepData) {
  let content = '';
  Object.entries(stepData).forEach(([publisherCode, value]) => {
    try {
      const publisherReturnData = JSON.parse(value);
      const publisherName = publisherReturnData.name || publisherCode;
      // tos
      if (publisherReturnData.extension?.toUpperCase() === 'PDF') {
        content += `<ewc-alert type="flat" label="${publisherName}"></ewc-alert>
        <ewc-pdf-viewer print download fullscreen scale="1" pdf-name="serviceconditions_${publisherName}.pdf" pdf64="${publisherReturnData.data}"></ewc-pdf-viewer>`;
      } else {
        content += `<div style="white-space:normal;font-family: monospace;">${parseLineBreak(decodeB64WithEncoding(publisherReturnData.data))}</div>`;
      }

      // agree
      content += `<ewc-checkbox name="checkMandatory"required label="${edicom.locale.translate('enrollment.bmcondicionesuso.label.agreement')}"></ewc-checkbox>`;
    } catch (error) {
      publisherCode !== 'type' && console.error(error);
    }
  });
  return content;
}
